import { Component, inject, OnInit, HostListener } from '@angular/core';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { FilterItem } from '../../../../../../shared/components/api/models/filterItem.model';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { CardPagamentoComponent } from '@app/shared/components/card-pagamento/card-pagamento.component';
import { MenuItem, ConfirmationService, MessageService } from 'primeng/api';
import { DrawerModule } from 'primeng/drawer';
import { CommonModule } from '@angular/common';
import { DetalhePagamentoComponent } from '../detalhe-pagamento/detalhe-pagamento.component';
import { PagamentosService } from '@app/shared/components/api/services/pagamentos.service';
import { forkJoin } from 'rxjs';
import { SkeletonLoaderComponent } from '@app/shared/components/skeleton-loader/skeleton-loader.component';
import { Menu } from 'primeng/menu';
import { DoadorCreditoService } from '@app/shared/components/api/services/doador-credito.service';
import { UserService } from '@app/auth/services/user.service';
import { ApoioService } from '@app/shared/components/api/services/apoio.service';
import { LoaderComponent } from '@app/shared/components/loader/loader.component';

@Component({
  selector: 'app-lista-pagamentos',
  imports: [
    DataVoidComponent,
    DetalhePagamentoComponent,
    CommonModule,
    DrawerModule,
    CardPagamentoComponent,
    PaginatorControlComponent,
    SearchBarComponent,
    SkeletonLoaderComponent,
    LoaderComponent
  ],
  standalone: true,
  providers: [
    EnumService,
    PagamentosService,
    DoadorCreditoService,
    UserService,
    ApoioService
  ],
  templateUrl: './lista-pagamentos.component.html',
  styleUrl: './lista-pagamentos.component.scss'
})
export class ListaPagamentosComponent implements OnInit {
  private readonly messageService = inject(MessageService);
  private readonly pagamentoService = inject(PagamentosService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly doadorCreditoService = inject(DoadorCreditoService);
  private readonly userService = inject(UserService);
  private readonly apoioService = inject(ApoioService);
  enumService = inject(EnumService);
  visible: boolean = false;
  loading: boolean = false;

  pagamento: any;
  pagamentoID: any;
  currentFilters: any;
  pagination: Pagination<any> = new Pagination<any>();

  estadoPagamentoOptins: any[] = [];
  metodoPagamentoOptions: any[] = [];

  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'ReferenciaPagamento',
      placeholder: 'Referência do pagamento',
      optionLabel: 'label',
      optionValue: 'value',
    },
    {
      type: 'dropdown',
      controlName: 'MetodoPagamentoENUM',
      options: this.metodoPagamentoOptions,
      placeholder: 'Método de pagamento',
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EstadoApoioENUM',
      options: this.estadoPagamentoOptins,
      placeholder: 'Seleccione o estado',
      optionLabel: 'label',
      optionValue: 'id'
    }
  ];

  ngOnInit(): void {
    this.getAllapoios();
    this.loadDropdowns();
  }

  getActionsByEstado(pagamento: any): MenuItem[] {
    const baseActions: MenuItem[] = [
      {
        label: 'Ver detalhes',
        icon: 'pi pi-eye',
        command: () => this.verDetalhe(pagamento),
      },
      // {
      //   label: 'Suporte técnico',
      //   icon: 'pi pi-comments',
      //   command: (event) => this.verDetalhe(event.item),

      // },
      {
        label: 'Reembolso',
        icon: 'pi pi-wallet',
        command: (event) => this.reembolsarPagamento(event?.item?.['data']),

      },
    ];

    return baseActions;
  }

  getAllapoios(filters?: any) {
    this.loading = true;
    const params = {
      ...filters,
      ...this.currentFilters,
      PageSize: this.pagination.pageSize || 5,
      PageNumber: this.pagination.pageNumber || 1,
      OrderBy: 'id desc',
    };

    this.apoioService.list(params).subscribe({
      next: (res) => {
        this.pagination = new Pagination<any>().deserialize(res);
        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Falha',
          detail: 'Não foi possível carregar pagamentos',
          life: 5000
        });
      }
    });
  }

  loadDropdowns() {
    forkJoin({
      estadoApoio: this.enumService.getAllEstadoApoio(),
      metodopagamento: this.enumService.getAllMetodoPagamento()
    }).subscribe((response) => {
      // Enums
      if (response.estadoApoio?.data) {
        this.estadoPagamentoOptins = Object.entries(response.estadoApoio.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
        this.filters[2].options = this.estadoPagamentoOptins;
      }
      if (response.metodopagamento?.data) {
        this.metodoPagamentoOptions = Object.entries(response.metodopagamento.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
        this.filters[1].options = this.metodoPagamentoOptions;
      }
    })
  }

  // Acoes de menu
  verDetalhe(pagamento: any) {
    this.pagamentoID = pagamento?.id;
    this.visible = true;
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== ''
      )
    );
    this.currentFilters = filters; // guardar filtros ja aplicados
    this.getAllapoios();
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllapoios();
  }

  // controle de menus
  openedMenu: Menu | null = null;

  setOpenedMenu(menu: Menu) {
    if (this.openedMenu && this.openedMenu !== menu) {
      this.openedMenu.hide();
    }
    this.openedMenu = menu;
  }

  clearOpenedMenu() {
    this.openedMenu = null;
  }

  @HostListener('document:click')
  onDocumentClick() {
    if (this.openedMenu) {
      this.openedMenu.hide();
      this.openedMenu = null;
    }
  }

  reembolsarPagamento(pagamento: any) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja reembolsar esta pagamento?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Reembolsar',
      },
      accept: () => {
        const params = {
          apoioID: pagamento.id,
          utilizadorAdminID: this.userService.getUserId()
        };
        this.loading = true;

        this.doadorCreditoService.store(params).subscribe({
          next: (res) => {
            if (res.retorno.codigo === 200) {
              this.loading = false;
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: 'Reembolso realizado com sucesso!',
                life: 5000,
              });
              this.getAllapoios();
            } else {
              this.loading = false;
              this.messageService.add({
                severity: 'warn',
                summary: 'Aviso',
                detail: res.retorno.mensagem || 'Falha ao processar reembolsos',
                life: 5000,
              });
            }
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Ocorreu um erro ao processar o reembolso.',
              life: 5000,
            });
            console.error(err);
            this.loading = false;
          }
        });
      },
      reject: () => {
        this.loading = false; // garantir
      },
    });
  }
}
